<template>
  <div class="products-block col-12">
    <p v-if="heading" class="text-lg text-center text-uppercase">
      {{ heading }}
    </p>

    <div class="products-grid">
      <ProductPreview
        v-for="product in products"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script setup>
import ProductPreview from '@/components/shop/ProductPreviewComponent'

defineProps({
  heading: { type: String, default: null },
  products: { type: Array, required: true }
})
</script>
